// This file is generated by Style Dictionary
const tokens = {
  interline: {
    stack: '4px',
  },
  form: {
    label: '4px',
    field: '24px',
  },
  textButton: {
    horizontal: '8px',
  },
  button: {
    inline: '8px',
    stack: '16px',
  },
  containedButton: {
    horizontal: '16px',
  },
  selection: {
    inline: '16px',
  },
  navigation: {
    inline: '16px',
  },
  table: {
    inset: '16px',
  },
  content: {
    stack: '16px',
  },
  surface: {
    inset: '24px',
  },
  contentButton: {
    stack: '24px',
  },
  section: {
    vertical: '48px',
    inline: '48px',
  },
};
export default tokens;
